import script from "./UserBlacklistHistorique.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserBlacklistHistorique.vue?vue&type=script&lang=ts&setup=true"

import "./UserBlacklistHistorique.vue?vue&type=style&index=0&id=72e91801&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e91801"]])

export default __exports__